export interface Error {
  code: ErrorCode;
  message: string;
}

export const enum ErrorCode {
  'MEDIA_ERROR' = 300,
  'PLAYER_BAD_REQUEST_ERROR' = 400,
  'PLAYER_AUTH_FAILED_ERROR' = 403,
  'PLAYER_NOT_ACCEPTABLE_ERROR' = 406,
  'UNKNOWN_ERROR' = 999,

  'MEDIA_ERR_ABORTED' = 1,
  'MEDIA_ERR_NETWORK' = 2,
  'MEDIA_ERR_DECODE' = 3,
  'MEDIA_ERR_SRC_NOT_SUPPORTED' = 4,
  'LIVESTREAM_NOT_AVAILABLE' = 5,

  'MANIFEST_LOADING_ERROR' = 1001,
  'MANIFEST_PARSING_ERROR' = 1002,
  'LEVEL_LOAD_ERROR' = 1003,
  'LEVEL_SWITCH_ERROR' = 1004,
  'FRAG_LOAD_ERROR' = 1005,
  'FRAG_PARSING_ERROR' = 1006,
  'BUFFER_APPEND_ERROR' = 1007,
  'KEY_LOAD_ERROR' = 1008,
  'KEY_SYSTEM_ERROR' = 1009,

  'MANIFEST_LOADER_LOADING_FAILURE' = 2001,
  'MANIFEST_LOADER_PARSING_FAILURE' = 2002,
  'SEGMENTS_UPDATE_FAILED' = 2003,
  'SEGMENT_BASE_LOADER_ERROR' = 2004,
  'APPEND_ERROR' = 2005,
  'MEDIASOURCE_ERROR' = 2006,
  'VIDEO_ELEMENT_ERROR' = 2007,
  'DOWNLOAD_ERROR' = 2008,
}


export const ErrorMessage = {
  codes: {
    [ErrorCode.MEDIA_ERROR]: {
      code: ErrorCode.MEDIA_ERROR,
      message: 'Media error',
    },
    [ErrorCode.PLAYER_BAD_REQUEST_ERROR]: {
      code: ErrorCode.PLAYER_BAD_REQUEST_ERROR,
      message: 'Bad request',
    },
    [ErrorCode.PLAYER_AUTH_FAILED_ERROR]: {
      code: ErrorCode.PLAYER_AUTH_FAILED_ERROR,
      message: 'Authentication failed',
    },
    [ErrorCode.PLAYER_NOT_ACCEPTABLE_ERROR]: {
      code: ErrorCode.PLAYER_NOT_ACCEPTABLE_ERROR,
      message: 'Not acceptable request',
    },
    [ErrorCode.UNKNOWN_ERROR]: {
      code: ErrorCode.UNKNOWN_ERROR,
      message: 'Unknown error',
    },
    [ErrorCode.MEDIA_ERR_ABORTED]: {
      code: ErrorCode.MEDIA_ERR_ABORTED,
      message: ' playback was aborted.',
    },
    [ErrorCode.MEDIA_ERR_NETWORK]: {
      code: ErrorCode.MEDIA_ERR_NETWORK,
      message: 'A network error prevented the video from playing.',
    },
    [ErrorCode.MEDIA_ERR_DECODE]: {
      code: ErrorCode.MEDIA_ERR_DECODE,
      message: 'An error prevented the video from being decoded.',
    },
    [ErrorCode.MEDIA_ERR_SRC_NOT_SUPPORTED]: {
      code: ErrorCode.MEDIA_ERR_SRC_NOT_SUPPORTED,
      message: 'The video format is not supported.',
    },
    [ErrorCode.LIVESTREAM_NOT_AVAILABLE]: {
      code: ErrorCode.LIVESTREAM_NOT_AVAILABLE,
      message: 'The livestream is not available.'
    },
    [ErrorCode.MANIFEST_LOADER_LOADING_FAILURE]: {
      code: ErrorCode.MANIFEST_LOADER_LOADING_FAILURE,
      message: 'Failed to load the video manifest.',
    },
    [ErrorCode.MANIFEST_LOADER_PARSING_FAILURE]: {
      code: ErrorCode.MANIFEST_LOADER_PARSING_FAILURE,
      message: 'Failed to parse the video manifest.',
    },
    [ErrorCode.SEGMENTS_UPDATE_FAILED]: {
      code: ErrorCode.SEGMENTS_UPDATE_FAILED,
      message: 'Failed to update the video segments.',
    },
    [ErrorCode.SEGMENT_BASE_LOADER_ERROR]: {
      code: ErrorCode.SEGMENT_BASE_LOADER_ERROR,
      message: 'Error loading the base segment for the video.',
    },
    [ErrorCode.APPEND_ERROR]: {
      code: ErrorCode.APPEND_ERROR,
      message: 'Error appending the video segment to the buffer.',
    },
    [ErrorCode.MEDIASOURCE_ERROR]: {
      code: ErrorCode.MEDIASOURCE_ERROR,
      message: 'An error occurred with the MediaSource API.',
    },
    [ErrorCode.VIDEO_ELEMENT_ERROR]: {
      code: ErrorCode.VIDEO_ELEMENT_ERROR,
      message: 'An error occurred with the video element.',
    },
    [ErrorCode.DOWNLOAD_ERROR]: {
      code: ErrorCode.DOWNLOAD_ERROR,
      message: 'An error occurred while downloading the video.',
    },
    [ErrorCode.MANIFEST_LOADING_ERROR]: {
      code: ErrorCode.MANIFEST_LOADING_ERROR,
      message: 'Error loading the video manifest file.',
    },
    [ErrorCode.MANIFEST_PARSING_ERROR]: {
      code: ErrorCode.MANIFEST_PARSING_ERROR,
      message: 'Error parsing the video manifest file.',
    },
    [ErrorCode.LEVEL_LOAD_ERROR]: {
      code: ErrorCode.LEVEL_LOAD_ERROR,
      message: 'Error loading the video quality level.',
    },
    [ErrorCode.LEVEL_SWITCH_ERROR]: {
      code: ErrorCode.LEVEL_SWITCH_ERROR,
      message: 'Error switching between video quality levels.',
    },
    [ErrorCode.FRAG_LOAD_ERROR]: {
      code: ErrorCode.FRAG_LOAD_ERROR,
      message: 'Error loading a video fragment.',
    },
    [ErrorCode.FRAG_PARSING_ERROR]: {
      code: ErrorCode.FRAG_PARSING_ERROR,
      message: 'Error parsing a video fragment.',
    },
    [ErrorCode.BUFFER_APPEND_ERROR]: {
      code: ErrorCode.BUFFER_APPEND_ERROR,
      message: 'Error appending data to the video buffer.',
    },
    [ErrorCode.KEY_LOAD_ERROR]: {
      code: ErrorCode.KEY_LOAD_ERROR,
      message: 'Error loading the decryption key.',
    },
    [ErrorCode.KEY_SYSTEM_ERROR]: {
      code: ErrorCode.KEY_SYSTEM_ERROR,
      message: 'Error with the key system (DRM).',
    },
  },
};
